// React
import React from "react";
import PropTypes from "prop-types";
// Moment
import moment from "moment";
// i18next
import { withNamespaces, Trans } from "react-i18next";
// Styles
import styles from "./BookingItem.css";
// const
import { ROLE_KEY } from "../../../../../services/auth.ducks";

const BookingItem = ({ data, isUserActive, onCancelClick, t }) => {
  const locationStreet = data.name ? ` - ${data.street}` : data.street;
  const isAdmin = localStorage.getItem(ROLE_KEY) === `admin`;
  const cancelButtonDisabled = !data.canBeCanceled || (!isAdmin && !isUserActive);

  return (
    <div className="col-sm-12 well" style={styles.container}>
      <div className="row">
        <div className="col-xs-9" style={styles.title}>
          {data.examTitle}
          <br />
          <span style={styles.subTitle}> {data.examSubTitle}</span>
        </div>
        <div className="col-xs-3" style={{ textAlign: `right` }}>
          {!cancelButtonDisabled && (
            <button className="btn btn-danger" onClick={() => onCancelClick(data)} type="button">
              {t(`modules.localization.register.generals.button.cancelBooking`)}
            </button>
          )}
        </div>
      </div>
      {/* Details */}
      <div style={styles.tab}>
        {t(`modules.localization.register.authenticated.bookings.details`)}
      </div>
      <div style={styles.tabContent}>
        <p>
          <Trans
            i18nKey="modules.localization.register.authenticated.bookings.date"
            values={{
              date: moment(data.date).format(`L`)
            }}
          >
            <b>{t(`modules.localization.register.authenticated.bookings.date`)}:</b>
          </Trans>
        </p>
        <p>
          <Trans
            i18nKey="modules.localization.register.authenticated.bookings.testDuration"
            values={{ duration: data.examDuration }}
          >
            <b>{t(`modules.localization.register.authenticated.bookings.testDuration`)}:</b>
          </Trans>
        </p>
        <p>
          <Trans
            i18nKey="modules.localization.register.authenticated.bookings.startTime"
            values={{
              startTime: moment(data.timeFrom, `HH:mm:ss`).format(`HH:mm`)
            }}
          >
            <b>{t(`modules.localization.register.authenticated.bookings.startTime`)}:</b>
          </Trans>
        </p>
      </div>
      {/* Location */}
      <div style={styles.tab}>
        {t(`modules.localization.register.authenticated.bookings.location`)}
      </div>
      <div style={styles.tabContent}>
        <p>
          <Trans
            i18nKey="modules.localization.register.authenticated.bookings.address"
            values={{
              name: data.name,
              street: locationStreet,
              postCode: data.postalCode,
              city: data.city
            }}
          >
            <b>{t(`modules.localization.register.authenticated.bookings.address`)}:</b>
          </Trans>
        </p>
        {data.email && (
          <p>
            <Trans
              i18nKey="modules.localization.register.authenticated.bookings.email"
              values={{ email: data.email }}
            >
              <b>{t(`modules.localization.register.authenticated.bookings.email`)}:</b>
            </Trans>
          </p>
        )}

        {data.www && (
          <p>
            <Trans
              i18nKey="modules.localization.register.authenticated.bookings.webAddress"
              values={{ webAddress: data.www }}
            >
              <b>{t(`modules.localization.register.authenticated.bookings.webAddress`)}:</b>
            </Trans>
          </p>
        )}
      </div>
    </div>
  );
};

BookingItem.propTypes = {
  data: PropTypes.shape({
    canBeCanceled: PropTypes.bool,
    city: PropTypes.string,
    date: PropTypes.string,
    email: PropTypes.string,
    examDuration: PropTypes.number,
    examTitle: PropTypes.string,
    examSubTitle: PropTypes.string,
    name: PropTypes.string,
    postalCode: PropTypes.string,
    street: PropTypes.string,
    timeFrom: PropTypes.string,
    www: PropTypes.string
  }),
  isUserActive: PropTypes.bool,
  onCancelClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(BookingItem);
